import React from 'react';
import Icon from '../../../components/AppIcon';

const HighSchoolPathway = ({ formData, errors, onChange, onCheckboxChange }) => {
  const gradeOptions = [
    { value: 'seconde', label: 'Seconde (2nde)' },
    { value: 'premiere', label: 'Première (1ère)' },
    { value: 'terminale', label: 'Terminale' }
  ];

  const seriesOptions = [
    { value: 'l', label: 'Série L (Littéraire)' },
    { value: 's', label: 'Série S (Scientifique)' },
    { value: 'es', label: 'Série ES (Économique et Social)' },
    { value: 'g', label: 'Série G (Gestion)' },
    { value: 't', label: 'Série T (Technique)' }
  ];

  const subjectOptions = [
    { id: 'mathematiques', label: 'Mathématiques', icon: 'Calculator' },
    { id: 'physique-chimie', label: 'Physique-Chimie', icon: 'Atom' },
    { id: 'svt', label: 'Sciences de la Vie et de la Terre', icon: 'Leaf' },
    { id: 'francais', label: 'Français', icon: 'BookOpen' },
    { id: 'philosophie', label: 'Philosophie', icon: 'Brain' },
    { id: 'histoire-geo', label: 'Histoire-Géographie', icon: 'Globe' },
    { id: 'anglais', label: 'Anglais', icon: 'Languages' },
    { id: 'economie', label: 'Économie', icon: 'TrendingUp' },
    { id: 'informatique', label: 'Informatique', icon: 'Laptop' },
    { id: 'arts', label: 'Arts', icon: 'Palette' }
  ];

  const academicGoalOptions = [
    { id: 'university', label: 'Université', icon: 'School' },
    { id: 'grandes-ecoles', label: 'Grandes Écoles', icon: 'Award' },
    { id: 'professional', label: 'Formation Professionnelle', icon: 'Briefcase' },
    { id: 'technical', label: 'BTS/DUT', icon: 'Tool' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
            <Icon name="Target" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Ton Parcours Lycéen
            </h3>
            <p className="text-sm text-gray-600">
              Aide-nous à comprendre ton niveau actuel et tes préférences académiques
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Niveau Actuel <span className="text-red-500">*</span>
          </label>
          <select
            name="currentGrade"
            value={formData?.currentGrade}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">Sélectionne ton niveau</option>
            {gradeOptions?.map((grade) => (
              <option key={grade?.value} value={grade?.value}>
                {grade?.label}
              </option>
            ))}
          </select>
          {errors?.currentGrade && (
            <p className="text-sm text-red-500 mt-1">{errors?.currentGrade}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Série
          </label>
          <select
            name="series"
            value={formData?.series}
            onChange={onChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="">Sélectionne ta série</option>
            {seriesOptions?.map((series) => (
              <option key={series?.value} value={series?.value}>
                {series?.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label className="block text-base font-semibold text-gray-900 mb-4">
          Matières Préférées <span className="text-red-500">*</span>
        </label>
        <p className="text-sm text-gray-600 mb-4">
          Sélectionne au moins 3 matières dans lesquelles tu excelles ou que tu apprécies
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {subjectOptions?.map((subject) => (
            <label
              key={subject?.id}
              className={`flex items-center gap-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${
                formData?.subjects?.includes(subject?.id)
                  ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-blue-300'
              }`}
            >
              <input
                type="checkbox"
                checked={formData?.subjects?.includes(subject?.id)}
                onChange={(e) => onCheckboxChange('subjects', subject?.id, e?.target?.checked)}
                className="w-5 h-5 text-blue-500 rounded focus:ring-blue-500"
              />
              <Icon name={subject?.icon} size={24} className="text-blue-600" />
              <span className="text-sm font-medium text-gray-900">{subject?.label}</span>
            </label>
          ))}
        </div>
        {errors?.subjects && (
          <p className="text-sm text-red-500 mt-2">{errors?.subjects}</p>
        )}
      </div>

      <div>
        <label className="block text-base font-semibold text-gray-900 mb-4">
          Objectifs Post-Bac
        </label>
        <p className="text-sm text-gray-600 mb-4">
          Quel type d'études envisages-tu après le baccalauréat ?
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {academicGoalOptions?.map((goal) => (
            <label
              key={goal?.id}
              className={`flex items-center gap-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${
                formData?.academicGoals?.includes(goal?.id)
                  ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-blue-300'
              }`}
            >
              <input
                type="checkbox"
                checked={formData?.academicGoals?.includes(goal?.id)}
                onChange={(e) => onCheckboxChange('academicGoals', goal?.id, e?.target?.checked)}
                className="w-5 h-5 text-blue-500 rounded focus:ring-blue-500"
              />
              <Icon name={goal?.icon} size={24} className="text-blue-600" />
              <span className="text-sm font-medium text-gray-900">{goal?.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HighSchoolPathway;